/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "antd";
import { TableRecordProps } from "../../ducks/types";

interface PropsType {
  proposal: any;
  setTableRecord: React.Dispatch<React.SetStateAction<TableRecordProps | null>>;
  handleCardStatusChange: (
    status: string,
    proposalId: string,
    hasDocument?: boolean | undefined
  ) => void;
}

export default function InProgress(props: PropsType) {
  const { proposal, handleCardStatusChange, setTableRecord } = props;
  return (
    <div
      className="status_card"
      style={{ border: "1px solid #6454F414", backgroundColor: "#E7EAFF99" }}
    >
      <div className="titleBar">
        <img src="/images/potential-deals/status/inprogress.svg" alt="" />
        <Button
          htmlType="button"
          className="violet-btn btn-sm"
          type="primary"
          onClick={() => {
            handleCardStatusChange(
              "approval_pending",
              proposal.id,
              proposal?.document
            );
            setTableRecord(proposal);
          }}
        >
          Send for approval
        </Button>
      </div>
      <h5>
        Status:{" "}
        <span style={{ color: "#4637D4", fontWeight: "700" }}>
          {/* {proposal.status} */}
          In progress
        </span>
      </h5>
      <h6
        style={{
          fontSize: "14px",
          lineHeight: "20px",
          fontWeight: "400",
        }}
      >
        {" "}
        Complete estimate and proposal doc.{" "}
      </h6>
    </div>
  );
}
